module.exports = __webpack_public_path__ + "img/unifg.70b8ce1d.svg";